import React, { useEffect } from 'react';
import {
  PRIVACY_CONTACT_EMAIL,
  PRIVACY_LAST_UPDATED,
  privacySections,
} from './privacyPolicyContent';

function linkEmail(text) {
  return text.split(PRIVACY_CONTACT_EMAIL).flatMap((part, i) =>
    i === 0
      ? [part]
      : [
          <a key={i} href={`mailto:${PRIVACY_CONTACT_EMAIL}`}>
            {PRIVACY_CONTACT_EMAIL}
          </a>,
          part,
        ]
  );
}

function PolicyListItem({ item }) {
  if (typeof item === 'string') return <li>{linkEmail(item)}</li>;
  return (
    <li>
      <strong>{item.term}</strong> {linkEmail(item.text)}
    </li>
  );
}

function PolicyBlock({ block }) {
  if (typeof block === 'string') return <p>{linkEmail(block)}</p>;
  if (block.list) {
    return (
      <ol className="policy-list">
        {block.list.map((item, i) => (
          <PolicyListItem key={i} item={item} />
        ))}
      </ol>
    );
  }
  return (
    <address className="policy-address">
      {block.address.map((line) => (
        <span key={line}>{linkEmail(line)}</span>
      ))}
    </address>
  );
}

function sectionNumber(index) {
  return String(index + 1).padStart(2, '0');
}

function PrivacyPolicy() {
  useEffect(() => {
    document.title = 'Privacy Policy | Chitragupta';
  }, []);

  return (
    <main className="policy-page">
      <section className="policy-hero">
        <div className="container">
          <span className="section-label">Legal</span>
          <h1 className="section-title">Privacy Policy</h1>
          <p className="policy-hero-text">
            How Chitragupta Urban Technologies Private Limited collects,
            safeguards, and discloses information when you use chitragupta.co.
          </p>
          <p className="policy-updated">Last updated: {PRIVACY_LAST_UPDATED}</p>
        </div>
      </section>

      <div className="container policy-layout">
        <aside className="policy-toc" aria-label="Privacy policy sections">
          <h2 className="policy-toc-title">On this page</h2>
          <ol>
            {privacySections.map((section, i) => (
              <li key={section.id}>
                <a href={`#${section.id}`}>
                  <span className="policy-toc-number">{sectionNumber(i)}</span>
                  {section.title}
                </a>
              </li>
            ))}
          </ol>
        </aside>

        <div className="policy-body">
          {privacySections.map((section, i) => (
            <section className="policy-section" id={section.id} key={section.id}>
              <div className="policy-section-head">
                <span className="policy-section-number">{sectionNumber(i)}</span>
                <h2>{section.title}</h2>
              </div>
              {section.blocks.map((block, j) => (
                <PolicyBlock key={j} block={block} />
              ))}
            </section>
          ))}
        </div>
      </div>
    </main>
  );
}

export default PrivacyPolicy;
